import React, { useState, useEffect } from 'react';
import { IoClose, IoChevronDown } from 'react-icons/io5';
import DealService from '../Services/DealService';
import { userUid } from '../../utils/storage';
import { showErrorToast, showInfoToast, showSuccessToast } from '../Constant/Notification';
import { ToastContainer } from 'react-toastify';

const PlotBookedForm = ({ isOpen, onClose , dealInfoSelected }) => {
  const [formData, setFormData] = useState({
    // Person Info
    applicantName: '',
    address: '',
    email: '',
    phoneNumber: '',
    profession: '',
    panNo: '',
    aadhaarNo: '',
    
    // Loan Info
    bankName: '',
    loanPercentage: '',
    ownLoan: '',
    
    // Nominee Info
    nomineeName: '',
    relationship: '',
    age: '',
    
    // Unit Info
    propertyName: dealInfoSelected?.property || '',
    unitNo: dealInfoSelected?.unit || '',
    sqftSize: dealInfoSelected?.squareFeet || '',
    pricePerSqft: dealInfoSelected?.pricePerSquareFeet || '',
    totalCost: '',
    
    // Booking Amount Details - Updated structure
    totalBookingAmount: '',
    modeOfPayment: [], // Changed to array for multiple selection
    paymentDetails: {}, // Store payment details for each mode
    
    // Creditable User
    creditableUserBookingAmount: '',
    creditableUser: '',
    
    // Additional fields to match payload
    createdBy: '', // Will be set from user context
    dealId: dealInfoSelected?.id || '',
    transactionRefNumber: '',
  });

  // Calculate total payload
  const [calculatedTotal, setCalculatedTotal] = useState(0);
  const [isUpdate , setIsUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=>{
   const fetchExistingBookedData = async () => {
    try {
       
        const response = await DealService.getPlotBookedByDealId(dealInfoSelected?.id)
        console.log("Existing booked data:", response.data)
        const data = response.data?.data;
        setIsUpdate(true);
      
            // Map response data to formData structure
            setFormData({
                applicantName: data.applicantName || '',
                address: data.address || '',
                email: data.email || '',
                phoneNumber: data.phoneNumber || '',
                profession: data.profession || '',
                panNo: data.panNo || '',
                aadhaarNo: data.aadhaarNo || '',
                bankName: data.bankName || '',
                loanPercentage: data.loanPercentage || '',
                ownLoan: data.ownLoan || '',
                nomineeName: data.nomineeName || '',
                relationship: data.relationship || '',
                age: data.age || '',
                propertyName: data.propertyName || dealInfoSelected?.property || '',
                unitNo: data.unitNo || dealInfoSelected?.unit || '',
                sqftSize: data.sqftSize || '',
                pricePerSqft: data.pricePerSqft || '',
                totalCost: data.totalCost || '',
                totalBookingAmount: data.totalBookingAmount || '',
                modeOfPayment: data.modeOfPayment ? data.modeOfPayment.map(mode => mode.toLowerCase()) : [],
                paymentDetails: data.paymentDetails || {},
                creditableUserBookingAmount: data.creditableUserBookingAmount || '',
                creditableUser: data.creditableUser || '',
                createdBy: data.createdBy || userUid || '',
                dealId: data.dealId || dealInfoSelected?.id || '',
                transactionRefNumber: data.transactionRefNumber || '',

            });
            setCalculatedTotal(response.data.totalCost || 0);
     
    } catch (error) {
        console.error("Error fetching existing booked data:", error);
        setIsUpdate(false);

   };
}
   fetchExistingBookedData();
  },[dealInfoSelected?.id , isOpen])

  useEffect(() => {
    const sqft = parseFloat(formData.sqftSize) || 0;
    const pricePerSqft = parseFloat(formData.pricePerSqft) || 0;
    const total = sqft * pricePerSqft;
    setCalculatedTotal(total);

    setFormData(prev => ({
      ...prev,
      totalCost: total.toString()
    }));
  }, [formData.sqftSize, formData.pricePerSqft]);

  const handleInputChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    // Basic validation for mandatory fields
    if(!formData.applicantName || !formData.address || !formData.phoneNumber || !formData.propertyName || !formData.unitNo || !formData.totalBookingAmount){
        setIsLoading(false);
        showInfoToast("Please fill all mandatory fields!");
        return;
    }

    // Individual field validations
    if(!formData.applicantName){
        setIsLoading(false);
        showInfoToast("Applicant name is required!");
        return;
    }

    if(!formData.address){
        setIsLoading(false);
        showInfoToast("Address is required!");
        return;
    }
    
    if(!formData.phoneNumber){
        setIsLoading(false);
        showInfoToast("Phone number is required!");
        return;
    }
    
    if(!formData.propertyName){
        setIsLoading(false);
        showInfoToast("Property name is required!");
        return;
    }
    
    if(!formData.unitNo){
        setIsLoading(false);
        showInfoToast("Unit number is required!");
        return;
    }
    
    if(!formData.sqftSize){
        setIsLoading(false);
        showInfoToast("Sqft size is required!");
        return;
    }
    
    if(!formData.pricePerSqft){
        setIsLoading(false);
        showInfoToast("Price per sqft is required!");
        return;
    }
    
    if(!formData.totalBookingAmount){
        setIsLoading(false);
        showInfoToast("Total booking amount is required!");
        return;
    }
    if(!formData.panNo){
        setIsLoading(false);
        showInfoToast("Pan number is required!");
        return;
    }
    if (!formData.panNo || formData.panNo.trim().length !== 10) {
      setIsLoading(false);
      showInfoToast("PAN number must be 10 characters!");
      return;
    }
      if(!formData.aadhaarNo){

          setIsLoading(false);
          showInfoToast("Aadhaar number is required!");
          return;
      }

      if (!formData.aadhaarNo || formData.aadhaarNo.trim().length !== 12) {
        setIsLoading(false);
        showInfoToast("Aadhaar number must be 12 digits!");
        return;
      }
    
    if(formData.modeOfPayment.length === 0){
        setIsLoading(false);
        showInfoToast("Please select at least one mode of payment!");
        return;
    }
    
    // Validate payment details for each selected mode
    if(formData.modeOfPayment.length > 0){
        for(const mode of formData.modeOfPayment){
            const details = formData.paymentDetails[mode.toLowerCase()];
            if(!details){
                setIsLoading(false);
                showInfoToast(`Please fill payment details for ${mode}!`);
                return;
            }
            if(mode.toLowerCase() === 'cash'){
                if(!details.amount || !details.date){
                    setIsLoading(false);
                    showInfoToast(`Please fill all payment details for ${mode}!`);
                    return;
                }
            } else {
                if(!details.transactionNo || !details.amount || !details.date){
                    setIsLoading(false);
                    showInfoToast(`Please fill all payment details for ${mode}!`);
                    return;
                }
            }
        }
    }

    // Validate that sum of payment mode amounts matches total booking amount
    let modeAmountTotal = 
        formData.modeOfPayment.reduce((sum, mode) => {
            const details = formData.paymentDetails[mode.toLowerCase()];
            const amount = details ? parseFloat(details.amount) || 0 : 0;
            return sum + amount;
        }, 0);

    if(modeAmountTotal !== parseFloat(formData.totalBookingAmount || 0)){
        setIsLoading(false);
        showInfoToast("The total booking amount does not match the sum of mode amounts!");
        return;
    }

    let updatePayload;
    let payload;
  
    // if (isUpdate) {
    //   updatePayload = {
    //     dealId: formData.dealId,
    //     modifiedBy: userUid,
    //     updatedData: {
    //       applicantName: formData.applicantName,
    //       address: formData.address,
    //       email: formData.email,
    //       phoneNumber: formData.phoneNumber,
    //       profession: formData.profession,
    //       panNo: formData.panNo,
    //       aadhaarNo: formData.aadhaarNo,
    //       bankName: formData.bankName,
    //       loanPercentage: formData.loanPercentage,
    //       ownLoan: formData.ownLoan,
    //       nomineeName: formData.nomineeName,
    //       relationship: formData.relationship,
    //       age: formData.age,
    //       propertyName: formData.propertyName,
    //       unitNo: formData.unitNo,
    //       sqftSize: formData.sqftSize,
    //       pricePerSqft: formData.pricePerSqft,
    //       totalCost: formData.totalCost,
    //       totalBookingAmount: formData.totalBookingAmount,
    //       modeOfPayment: formData.modeOfPayment.map((mode) =>
    //         mode.toLowerCase()
    //       ),
    //       paymentDetails: formData.paymentDetails,
    //       creditableUserBookingAmount: formData.creditableUserBookingAmount,
    //       creditableUser: formData.creditableUser,
    //       transactionRefNumber: formData.transactionRefNumber || null,
    //     },
    //   };
    // } else {
      payload = {
        createdBy: userUid || "",
        modifiedBy : userUid || "",
        dealId: formData.dealId || "",
        applicantName: formData.applicantName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        propertyName: formData.propertyName,
        unitNo: formData.unitNo,
        totalBookingAmount: formData.totalBookingAmount,
        totalCost: formData.totalCost,
        modeOfPayment: formData.modeOfPayment.map((mode) => mode.toLowerCase()),
        paymentDetails: formData.paymentDetails,
        aadhaarNo: formData.aadhaarNo,
        address: formData.address,
        age: formData.age,
        bankName: formData.bankName,
        creditableUser: formData.creditableUser,
        creditableUserBookingAmount: formData.creditableUserBookingAmount,
        loanPercentage: formData.loanPercentage,
        nomineeName: formData.nomineeName,
        ownLoan: formData.ownLoan,
        panNo: formData.panNo,
        pricePerSqft: formData.pricePerSqft,
        profession: formData.profession,
        relationship: formData.relationship,
        sqftSize: formData.sqftSize,
        transactionRefNumber: formData.transactionRefNumber || null,
      };
    // }
    try {
      const config = { responseType: "blob" };
      let res;
    
      // if (isUpdate) {
      //   res = await DealService.updatePlotBooked(updatePayload, config);
      // } else {
        res = await DealService.createPlotBooked(payload, config);
      // }
    
      console.log("Server Response:", res);
    
      if (res.status === 200) {
        const contentType = res.headers["content-type"];
       
        // ✅ Always show toast + close modal first
        showSuccessToast(
          typeof res.data === "string"
            ? res.data
            : res.data?.message || "Form submitted successfully!"
        );
        setTimeout(() => {
          onClose?.();
          setIsLoading(false); // Stop loading
        }, 3000); // Close modal after 3 seconds
    
       
    
        // ✅ Then, only if response is a PDF → download
        if (contentType && contentType.includes("application/pdf")) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
    
          // Enhanced filename generation
          const sanitizeName = (name) =>
            name ? name.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "_") : "";
    
          const applicantName =
            sanitizeName(formData.applicantName) || "UnknownApplicant";
          const propertyName = sanitizeName(formData.propertyName) || "Property";
          const unitNo = sanitizeName(formData.unitNo) || "Unit";
    
          const disposition = res.headers["content-disposition"];
          const match = disposition && disposition.match(/filename="?(.+)"?/);
          const filename = match
            ? match[1]
            : `${applicantName}_${propertyName}.pdf`;
    
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      } else {
        // ❌ Don’t show toast or download for non-200
        console.error("Unexpected status:", res.status);
        showErrorToast(`Error ${res.status}: ${res.statusText}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showErrorToast("Failed to submit form!");
      setIsLoading(false);
    } 
    
  };
  
  

  const handleClose = () => {
    onClose?.();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  // Payment modes configuration
  const paymentModes = [
    { value: 'cash', label: 'Cash' },
    { value: 'dd', label: 'DD' },
    { value: 'upi', label: 'UPI' },
    { value: 'neft', label: 'NEFT' },
    { value: 'rtgs', label: 'RTGS' },
    {value: 'imps', label: 'IMPS'}
  ];

  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);

  const handlePaymentModeToggle = (modeValue) => {
    const updatedModes = formData.modeOfPayment.includes(modeValue)
      ? formData.modeOfPayment.filter(mode => mode !== modeValue)
      : [...formData.modeOfPayment, modeValue];

    setFormData(prev => ({
      ...prev,
      modeOfPayment: updatedModes,
      paymentDetails: {
        ...prev.paymentDetails,
        [modeValue.toLowerCase()]: updatedModes.includes(modeValue) 
          ? (modeValue.toLowerCase() === 'cash' 
              ? { amount: '', date: '' }
              : { transactionNo: '', amount: '', date: '' }) // Use transactionNo, amount for non-cash payments
          : undefined
      }
    }));
  };

  const handlePaymentDetailChange = (mode, field, value) => {
    const lowerMode = mode
    setFormData(prev => ({
      ...prev,
      paymentDetails: {
        ...prev.paymentDetails,
        [lowerMode]: {
          ...prev.paymentDetails[lowerMode],
          [field]: value
        }
      }
    }));
  };

  const getSelectedPaymentLabels = () => {
    if (formData.modeOfPayment.length === 0) return 'Select Mode of Payment';
    return formData.modeOfPayment
      .map(mode => paymentModes.find(pm => pm.value === mode)?.label)
      .join(', ');
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
        <ToastContainer/>
      <div className="bg-white w-full max-w-4xl max-h-[90vh] overflow-hidden rounded-lg shadow-xl">
        {/* Header */}
        <div className="bg-white shadow-sm border-b sticky top-0 z-10">
          <div className="flex items-center justify-between p-4">
            <h1 className="text-lg font-semibold text-gray-800">Unit Booked Form</h1>
            <button
              onClick={handleClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <IoClose size={20} />
            </button>
          </div>
        </div>

        {/* Form Content */}
        <div className="overflow-y-auto max-h-[calc(90vh-80px)]">
          <form onSubmit={handleSubmit} className="p-6">
            
            {/* Person Info Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b">Person Info</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Applicant Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="applicantName"
                    maxLength={100}
                    value={formData.applicantName || ''}
                    onChange={(e) => handleInputChange('applicantName', e.target.value)}
                    placeholder="Enter Applicant name"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="address"
                    maxLength={200}
                    value={formData.address || ''}
                    onChange={(e) => handleInputChange('address', e.target.value)}
                    placeholder="Enter Address"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email ID
                  </label>
                  <input
                    type="email"
                    name="email"
                    maxLength={160}
                    value={formData.email || ''}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    placeholder="Enter Email Address"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    maxLength={10}
                    value={formData.phoneNumber || ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      if (value.length <= 10) {
                        handleInputChange('phoneNumber', value);
                      }
                    }}
                    placeholder="Phone Number"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Profession
                  </label>
                  <input
                    type="text"
                    name="profession"
                    maxLength={50}
                    value={formData.profession || ''}
                    onChange={(e) => handleInputChange('profession', e.target.value)}
                    placeholder="Enter Profession"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Pan No. <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="panNo"
                    maxLength={10}
                    value={formData.panNo || ''}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                      if (value.length <= 10) {
                        handleInputChange('panNo', value);
                      }
                    }}
                    placeholder="Enter Pan No (AAAPL1234C)"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Aadhaar No. <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="aadhaarNo"
                    maxLength={12}
                    value={formData.aadhaarNo || ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      if (value.length <= 12) {
                        handleInputChange('aadhaarNo', value);
                      }
                    }}
                    placeholder="Enter 12-digit Aadhaar No."
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
              </div>
            </div>

            {/* Loan Info Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b">Loan Info</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    maxLength={100}
                    value={formData.bankName || ''}
                    onChange={(e) => handleInputChange('bankName', e.target.value)}
                    placeholder="Enter Bank Name"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Loan Percentage %</label>
                  <input
                    type="text"
                    name="loanPercentage"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={3}
                    value={formData.loanPercentage || ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value <= 100) {
                        handleInputChange("loanPercentage", value);
                      }
                    }}
                    placeholder="Enter % (0-100)"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Own Loan %</label>
                  <input
                    type="text"
                    name="ownLoan"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={3}
                    value={formData.ownLoan || ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value <= 100) {
                        handleInputChange('ownLoan', value);
                      }
                    }}
                    placeholder="Enter % (0-100)"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
              </div>
            </div>

            {/* Nominee Info Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b">Nominee Info</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nominee Name</label>
                  <input
                    type="text"
                    name="nomineeName"
                    maxLength={100}
                    value={formData.nomineeName || ''}
                    onChange={(e) => handleInputChange('nomineeName', e.target.value)}
                    placeholder="Enter Nominee Name"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Relationship</label>
                  <input
                    type="text"
                    name="relationship"
                    maxLength={30}
                    value={formData.relationship || ''}
                    onChange={(e) => handleInputChange('relationship', e.target.value)}
                    placeholder="Enter Relationship"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Age</label>
                  <input
                    type="number"
                    name="age"
                    min="0"
                    max="150"
                    value={formData.age || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,3}$/.test(value) && (value === '' || (parseInt(value) >= 0 && parseInt(value) <= 150))) {  
                        handleInputChange("age", value);
                      }
                    }}
                    placeholder="Enter Age (0-150)"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
              </div>
            </div>

            {/* Unit Info Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b">Unit Info</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Property Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="propertyName"
                    value={formData.propertyName || ''}
                    onChange={(e) => handleInputChange('propertyName', e.target.value)}
                  
                   
                    placeholder="Enter Property Name"
                    readOnly
                   className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none bg-gray-100 cursor-not-allowed"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Unit No <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="unitNo"
                    value={formData.unitNo || ''}
                    onChange={(e) => handleInputChange('unitNo', e.target.value)}
                    placeholder="Enter Unit No"
                    readOnly
                   className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none bg-gray-100 cursor-not-allowed"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    SQ.FT Size <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="sqftSize"
                    value={formData.sqftSize || ''}
                    onChange={(e) => handleInputChange('sqftSize', e.target.value.replace(/[^0-9.]/g, ''))}
                    placeholder="Enter SQ.FT Size"
                    readOnly
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none bg-gray-100 cursor-not-allowed"
              
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Price per SQ.FT <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="pricePerSqft"
                    length={10}
                    value={formData.pricePerSqft || ''}
                    onChange={(e) => handleInputChange('pricePerSqft', e.target.value.replace(/[^0-9.]/g, ''))}
                    placeholder="Price per SQ.FT"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Total Cost</label>
                  <input
                    type="text"
                    name="totalCost"
                    value={formData.totalCost || ''}
                    readOnly
                    placeholder="Unit Total Cost"
                    className="w-full p-3 border border-gray-300 focus:outline-none rounded-lg bg-gray-100 cursor-not-allowed"
                  />
                </div>
               
              </div>
            </div>

            {/* Booking Amount Details Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b">Booking Amount Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Total Booking Amount <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="totalBookingAmount"
                    maxLength={15}
                    value={formData.totalBookingAmount || ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, '');
                      // Allow only one decimal point
                      const parts = value.split('.');
                      if (parts.length <= 2) {
                        handleInputChange('totalBookingAmount', value);
                      }
                    }}
                    placeholder="Type Total Booking Amount"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Transaction Reference Number
                  </label>
                  <input
                    type="text"
                    name="transactionRefNumber"
                    maxLength={50}
                    value={formData.transactionRefNumber || ''}
                    onChange={(e) => handleInputChange('transactionRefNumber', e.target.value)}
                    placeholder="Enter Transaction Reference Number"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
                
                {/* Multiple Selection Payment Mode Dropdown */}
                <div className="mb-4 relative">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mode of Payment <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
                      className="w-full p-3 border border-gray-300 rounded-lg input-focus text-left flex items-center justify-between bg-white"
                    >
                      <span className={formData.modeOfPayment.length === 0 ? 'text-gray-400' : 'text-gray-900'}>
                        {getSelectedPaymentLabels()}
                      </span>
                      <IoChevronDown className={`transform transition-transform ${showPaymentDropdown ? 'rotate-180' : ''}`} />
                    </button>
                    
                    {showPaymentDropdown && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        {paymentModes.map((mode) => (
                          <label key={mode.value} className="flex items-center p-3 hover:bg-gray-50 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.modeOfPayment.includes(mode.value)}
                              onChange={() => handlePaymentModeToggle(mode.value)}
                              className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <span className="text-sm text-gray-900">{mode.label}</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Dynamic Payment Detail Fields */}
              {formData.modeOfPayment.length > 0 && (
                <div className="mt-6 space-y-6">
                  {formData.modeOfPayment.map((mode) => {
                    const modeLabel = paymentModes.find(pm => pm.value === mode)?.label;
                    
                    return (
                      <div key={mode} className="border border-gray-200 rounded-lg p-4">
                        <h4 className="text-md font-medium text-gray-700 mb-4 border-b pb-2">
                          {modeLabel} Details
                        </h4>
                        
                        {mode.toLowerCase() === 'cash' ? (
                          // Cash - Show amount and date fields
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                Cash Amount <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                maxLength={15}
                                value={formData.paymentDetails[mode.toLowerCase()]?.amount || ''}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9.]/g, '');
                                  const parts = value.split('.');
                                  if (parts.length <= 2) {
                                    handlePaymentDetailChange(mode, 'amount', value);
                                  }
                                }}
                                placeholder="Enter cash amount"
                                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                                required
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                Payment Date <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="date"
                                value={formData.paymentDetails[mode.toLowerCase()]?.date || ''}
                                onChange={(e) => handlePaymentDetailChange(mode, 'date', e.target.value)}
                                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                                required
                              />
                            </div>
                          </div>
                        ) : (
                          // Other modes - Show reference/account number, amount, and date fields
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                {mode.toLowerCase() === 'dd' ? 'DD Number' :
                                 mode.toLowerCase() === 'upi' ? 'UPI Transaction ID' :
                                 mode.toLowerCase() === 'neft' ? 'NEFT Reference' :
                                 mode.toLowerCase() === 'rtgs' ? 'RTGS Reference' : 
                                 mode.toLowerCase() === 'imps' ? 'IMPS Number' : 'Reference Number'} <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                maxLength={50}
                                value={formData.paymentDetails[mode.toLowerCase()]?.transactionNo || ''}
                                onChange={(e) => handlePaymentDetailChange(mode, 'transactionNo', e.target.value)}
                                placeholder={`Enter ${mode.toLowerCase() === 'dd' ? 'DD number' :
                                             mode.toLowerCase() === 'upi' ? 'UPI transaction ID' :
                                             mode.toLowerCase() === 'neft' ? 'NEFT reference' :
                                             mode.toLowerCase() === 'rtgs' ? 'RTGS reference' :
                                             mode.toLowerCase() === 'imps' ? 'IMPS number' : 'reference number'}`}
                                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                                required
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                Amount <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                maxLength={15}
                                value={formData.paymentDetails[mode.toLowerCase()]?.amount || ''}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9.]/g, '');
                                  const parts = value.split('.');
                                  if (parts.length <= 2) {
                                    handlePaymentDetailChange(mode, 'amount', value);
                                  }
                                }}
                                placeholder="Enter amount"
                                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                                required
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-2">
                                {mode.toLowerCase() === 'dd' ? 'DD Date' :
                                 mode.toLowerCase() === 'upi' ? 'Transaction Date' :
                                 mode.toLowerCase() === 'neft' ? 'NEFT Date' :
                                 mode.toLowerCase() === 'rtgs' ? 'RTGS Date' :
                                 mode.toLowerCase() === 'cheque' ? 'Cheque Date' : 'Transaction Date'} <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="date"
                                value={formData.paymentDetails[mode.toLowerCase()]?.date || ''}
                                onChange={(e) => handlePaymentDetailChange(mode, 'date', e.target.value)}
                                className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                                required
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Creditable User Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-800 mb-4 pb-2 border-b">Creditable User</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Creditable User</label>
                  <textarea
                    type="text"
                    name="creditableUser"
                    rows={3}
                    value={formData.creditableUser || ''}
                    onChange={(e) => handleInputChange('creditableUser', e.target.value)}
                    placeholder="Type User"
                    className="w-full p-3 border border-gray-300 rounded-lg input-focus"
                  />
                </div>
               
              </div>
            </div>

            {/* Submit Buttons */}
            <div className="flex gap-3  bottom-0 bg-white sticky p-4 border-t">
              <button
                type="button"
                onClick={handleClose}
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-3 px-4 rounded-lg transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className={`flex-1 font-medium py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center ${
                  isLoading 
                    ? 'bg-gray-400 cursor-not-allowed text-white' 
                    : 'bg-green-600 hover:bg-green-700 text-white'
                }`}
              >
                {isLoading ? (
                  <>
                    <svg 
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
                      xmlns="http://www.w3.org/2000/svg" 
                      fill="none" 
                      viewBox="0 0 24 24"
                    >
                      <circle 
                        className="opacity-25" 
                        cx="12" 
                        cy="12" 
                        r="10" 
                        stroke="currentColor" 
                        strokeWidth="4"
                      ></circle>
                      <path 
                        className="opacity-75" 
                        fill="currentColor" 
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Processing...
                  </>
                ) : (
                  'Download'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PlotBookedForm;